import { render, staticRenderFns } from "./ShiftsCalendar.vue?vue&type=template&id=21bff016&scoped=true&"
import script from "./ShiftsCalendar.vue?vue&type=script&lang=js&"
export * from "./ShiftsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsCalendar.vue?vue&type=style&index=0&id=21bff016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bff016",
  null
  
)

export default component.exports